import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import { Observable } from 'rxjs';
import { Config } from '../app.configs';

@Injectable({
  providedIn: 'root'
})
export class TransferService {
  constructor(
    private http: HttpClient,
    private authService: AuthService
  ) { }

  createTransfer(uuid: string, payload = {}): Observable<any> {
    const headers = this.authService.getHeaders();

    return this.http.post(
      Config.toApiUrl(`dashboard/users/${uuid}/transfers/`), payload, { headers, withCredentials: true }
    );
  }
}
